import * as React from 'react';

import { observer } from 'mobx-react';
import styled from 'styled-components';

import { OutlinedButton, TextButton } from '@estee/elc-buttons';

import { useTranslation } from '~utils/hooks/translations';

export interface IPasswordHelpProps {
    isSubmitting: boolean;
    resetPasswordClicked(): void;
    emailMeCodeToSignInClicked(): void;
}

const ArrowIcon = styled.div`
    border: solid black;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3.5px;
    transform: rotate(45deg);
    margin-block-end: 10px;
`;

const PasswordHelpButton = styled(TextButton)`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;

    span {
        text-transform: none;
    }
`;

const PasswordHelpOptionButton = styled(OutlinedButton)`
    margin-block-end: 16px;
`;

const passwordHelpOptionClassName = 'elc-iam-password-help-option-button';

export const PasswordHelp = observer((props: IPasswordHelpProps) => {
    const [passwordHelpNeeded, setPasswordHelpNeeded] = React.useState(false);

    const { isSubmitting, resetPasswordClicked, emailMeCodeToSignInClicked } = props;

    const { emailMeCodeToSignIn, resetPasswordAction, needHelpWithYourPassword } = useTranslation();

    const needPasswordHelpClicked = () => {
        setPasswordHelpNeeded(!passwordHelpNeeded);
    };

    return (
        <div className="elc-iam-password-help">
            <PasswordHelpButton
                className="elc-iam-password-help-button"
                onClick={needPasswordHelpClicked}
            >
                <span>{needHelpWithYourPassword}</span>
                <ArrowIcon />
            </PasswordHelpButton>
            {passwordHelpNeeded && (
                <>
                    <PasswordHelpOptionButton
                        className={passwordHelpOptionClassName}
                        disabled={isSubmitting}
                        onClick={resetPasswordClicked}
                    >
                        {resetPasswordAction}
                    </PasswordHelpOptionButton>
                    <PasswordHelpOptionButton
                        className={passwordHelpOptionClassName}
                        disabled={isSubmitting}
                        onClick={emailMeCodeToSignInClicked}
                    >
                        {emailMeCodeToSignIn}
                    </PasswordHelpOptionButton>
                </>
            )}
        </div>
    );
});
